import React from 'react';
import { Container, Card, CardMedia, CardContent, Typography, Stack, Button } from '@mui/material';
import hamRadioImage from '../images/ham_radio.jpg';
import APRSChat36 from '../software/APRSChat_Setup_0.0.36.exe';
import APRSChat42 from '../software/APRSChat_Setup_0.0.42.exe';
import APRSChat50 from '../software/APRSChat_Setup_0.0.50.exe';

const Software = () => {
  return (
    <Container maxWidth="lg">
      <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 4 }}>
        Software Downloads
      </Typography>
      <Card>
        <CardMedia component="img" height="260" image={hamRadioImage} alt="Ham Radio" />
        <CardContent>
          <Typography variant="h5" component="h2" gutterBottom>
            APRS Chat
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            A chat platform for group and individual messaging through traditional APRS infrastructure.
          </Typography>
          <Typography variant="subtitle2" sx={{ mb: 2 }}>
            Current Version: 0.0.50 (Alpha 50)
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Button variant="outlined" href={APRSChat36}>
              Download (Alpha 36)
            </Button>
            <Button variant="outlined" href={APRSChat42}>
              Download (Alpha 42)
            </Button>
            <Button variant="contained" href={APRSChat50}>
              Download (Alpha 50)
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Software;
